import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ChatFilesPageUI from './ChatFilesPageUI.js'

class ChatFilesPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chatFilesList: [],
      fileDownloadSubmitted: false,
      fileErrorList: [],
    }
  }

  render() {
    return (
      <ChatFilesPageUI
        context={this.props.context}
        account={this.state.account}
        chatFilesList={this.state.chatFilesList}
        onRefreshClick={this.onRefreshClick}
        onDocDownloadClick={this.onDocDownloadClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getChatFiles(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getChatFiles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/chatFiles`,
      cacheKey: CacheKeys.ChatFiles(this.props.match.params.accountId),
      callback: this.getChatFilesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getChatFilesCallback = (response) => {
    this.setState({ chatFilesList: response.chatFiles })
  }

  onDocDownloadClick = (event) => {
    let fileId = event.currentTarget.getAttribute('data-file-id');
    let fileName = event.currentTarget.getAttribute('data-file-name');

    this.setState({ fileDownloadSubmitted: true });

    RestApiUtils.get(
      this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/files/${fileId}/fileName/${fileName}/fileDownloadSignedUrl`,
      this.onDocDownloadClickCallback,
      null
    );
  };

  onDocDownloadClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      fileDownloadSubmitted: false,
    });

    if (response.errorList.length === 0) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ChatFiles(this.props.match.params.accountId))
    this.setState({ chatFilesList: [] },
      this.getChatFiles(this.props.context)
    )
  }
}

export default withRouter(ChatFilesPageSF)
